var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComponentChainsPlaceholder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13087_49358",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2.31579,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13087_49358)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5455 8.99998C15.5455 12.6149 12.615 15.5454 9.00004 15.5454C5.38509 15.5454 2.45459 12.6149 2.45459 8.99998C2.45459 5.38503 5.38509 2.45453 9.00004 2.45453C12.615 2.45453 15.5455 5.38503 15.5455 8.99998ZM11.8903 6.95453H11.8441C11.1778 6.95453 10.7663 7.68136 11.1091 8.25267L11.2929 8.55899C11.4557 8.83043 11.4557 9.16954 11.2929 9.44098L11.1091 9.74729C10.7663 10.3186 11.1778 11.0454 11.8441 11.0454H11.8903C12.1914 11.0454 12.4704 10.8875 12.6253 10.6293L13.3383 9.44098C13.5012 9.16954 13.5012 8.83043 13.3383 8.55899L12.6253 7.37068C12.4704 7.1125 12.1914 6.95453 11.8903 6.95453ZM5.23441 7.07787L5.36096 6.95386C5.4092 6.93121 5.46061 6.91442 5.5152 6.90348H6.58302C6.50105 6.47254 6.66451 6.16511 7.07342 5.98116C7.49682 5.87592 7.81322 6.01284 8.0226 6.39194C8.09381 6.55781 8.10698 6.72832 8.06214 6.90348H8.21576C8.27939 6.75952 8.42344 6.65906 8.59095 6.65906C8.98599 6.65906 9.35361 6.861 9.56551 7.19439L10.2811 8.32026C10.5447 8.73505 10.5447 9.26489 10.2811 9.67968L9.56551 10.8056C9.35361 11.1389 8.98599 11.3409 8.59095 11.3409C8.42347 11.3409 8.27944 11.2405 8.2158 11.0965H8.06214C8.14411 11.5275 7.98065 11.8349 7.57174 12.0189C7.22682 12.1172 6.93944 12.0294 6.70958 11.7553C6.56636 11.554 6.52417 11.3344 6.58302 11.0965H5.5152C5.46061 11.0856 5.4092 11.0688 5.36096 11.0462L5.23441 10.9221C5.2113 10.8749 5.19416 10.8245 5.18299 10.771V9.58517C5.22107 9.39583 5.33708 9.31574 5.53102 9.34491C5.73637 9.4482 5.91829 9.4172 6.0768 9.2519C6.20334 9.06362 6.1928 8.88277 6.04516 8.70936C5.88603 8.57461 5.71465 8.55653 5.53102 8.65511C5.33708 8.68427 5.22107 8.60419 5.18299 8.41484V7.229C5.19416 7.17551 5.2113 7.12513 5.23441 7.07787Z",
    fill: "#B2BCEB"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponentChainsPlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/component-chains-placeholder.6ca8737ab287ad1558001c224a4bf59c.svg";